import axios from "axios";
import { getConfig } from "../../context/ConfigContext";
import { getSlug, getDeviceKey } from "../../tenant";

export const api = axios.create({
  baseURL: getConfig().baseURLAPI,
});

// Inject the current client slug into every /v1 call, so components keep using
// plain paths (e.g. api.get("v1/empreendimentos")) unchanged and the request
// becomes tenant-scoped: v1/{slug}/empreendimentos.
api.interceptors.request.use((config) => {
  const slug = getSlug();
  if (slug && config.url) {
    config.url = config.url.replace(/^\/?v1\//, `v1/${slug}/`);
  }
  // A Magic Folio box identifies itself on every call (per-box content filter).
  // Same param on every request = same URL the service worker caches by.
  const device = getDeviceKey();
  if (device) {
    config.params = { ...(config.params || {}), device };
  }
  return config;
});
